module.exports = __webpack_public_path__ + "img/logo.e161d919.png";